export enum AboutAction {
    UPDATE_ABOUT = 'UPDATE_ABOUT'
  }
  
  export type AboutType = {
    announcementExt: string, 
    announcements: string,
    documents: {displayName: string, fileName:string}[],
    weeklyLeaderBoards: any, 
  }

  
  interface UpdateAboutData {
    type: AboutAction.UPDATE_ABOUT,
    AboutData: AboutType,
    gameId: string
  }
  
  export type UpdateAboutActionTypes = UpdateAboutData;